import User from './User';
import { WorkflowState } from './enums/WorkflowState';

export default class WorkflowInstanceState {
	onPremWorkflowInstanceId!: number;

	onPremWorkflowState!: WorkflowState;

	performedByUser!: User;

	performedOnDate!: Date;

	performedByRoles!: string;

	performedReason!: string;

	ticketId!: string;

	action!: string;
	
    workflowState: WorkflowState;

	constructor(obj: any) {
		Object.assign(this, obj);
		this.onPremWorkflowState = new WorkflowState().fromValue(obj.onPremWorkflowState?.value);
	}
}